export const setCookie = (name: string, value: string, days?: number): void => {
  // Use Secure flag in production (HTTPS)
  const isSecure = window.location.protocol === 'https:';
  let cookieString = `${name}=${encodeURIComponent(value)};path=/;SameSite=Lax`;

  if (isSecure) {
    cookieString += ';Secure';
  }

  if (days !== undefined) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    cookieString += `;expires=${expires.toUTCString()}`;
  } else {
    // Set to year 9999 for "never expire"
    cookieString += `;expires=Fri, 31 Dec 9999 23:59:59 GMT`;
  }
  document.cookie = cookieString;
};

export const getCookie = (name: string): string | null => {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    cookie = cookie.trim();
    if (cookie.indexOf(nameEQ) === 0) {
      return decodeURIComponent(cookie.substring(nameEQ.length));
    }
  }
  return null;
};

export const deleteCookie = (name: string): void => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
};
